/**
 * Created by gocey on 28.08.17.
 */

Box.Application.addModule('sv-gallery', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareTabs = function() {
        _self.$element = $(context.getElement());
    };

    var _initTabs = function() {
        _self.$element.Chocolat({
            imageSelector: '.sv-gallery-image',
            container: window
        });
    };

    return {

        init: function() {
            _prepareTabs();
            _initTabs();
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-gallery.js